import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemRmName, FormItemRmNo} from '../RULEMRM/FormChooseRulemrm.jsx'
import Model from '../RULEMRMRULE/ModelRulemrmrule.mjs'

export const FormItemRuleTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleTitle"
        label="重要规则标题"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemRuleUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleUserCode"
        label="重要规则代码"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseRulemrmrule(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemRmNo />
            <FormItemRmName />
            <FormItemRuleUserCode />
            <FormItemRuleTitle />
        </FormChooseDesign>
    )
}
